export default import.meta.ROLLDOWN_FILE_URL_LVdgSM_ociFhP5jlDaPsnQ